import ShopifyObject from './ShopifyObject';

export default class CartItem extends ShopifyObject {
  /**
   * @param {ShopifyCollection} cartItem
   */
  constructor(cartItem) {
    super(cartItem.id);

    this._properties = cartItem.properties || null;
    this._quantity = cartItem.quantity || 0;
    this._variantID = cartItem.variant_id || 0;
    this._key = cartItem.key || '';
    this._title = cartItem.title || '';
    this._price = cartItem.price || 0;
    this._originalPrice = cartItem.original_price || 0;
    this._discountedPrice = cartItem.discounted_price || 0;
    this._linePrice = cartItem.line_price || 0;
    this._originalLinePrice = cartItem.original_line_price || 0;
    this._totalDiscount = cartItem.total_discount || 0;
    this._discounts = cartItem.discounts || 0;
    this._sku = cartItem.sku || '';
    this._grams = cartItem.grams || 0;
    this._vendor = cartItem.vendor || '';
    this._taxable = cartItem.taxable || true;
    this._productID = cartItem.product_id || 0;
    this._giftCard = cartItem.gift_card || false;
    this._finalPrice = cartItem.final_price || 0;
    this._finalLinePrice = cartItem.final_line_price || 0;
    this._url = cartItem.url || '';
    this._image = cartItem.image || '';
    this._handle = cartItem.handle || '';
    this._requiresShipping = cartItem.requires_shipping || true;
    this._productType = cartItem.product_type || '';
    this._productTitle = cartItem.product_title || '';
    this._productDescription = cartItem.product_description || '';
    this._variantTitle = cartItem.variant_title || '';
    this._variantOptions = cartItem.variant_options || [];
    this._lineLevelDiscountAllocations =
      cartItem.line_level_discount_allocations || [];
  }

  /**
   * @returns {object}
   */
  get properties() {
    return this._properties;
  }

  /**
   * @param {object}
   */
  set properties(properties) {
    this._properties = properties;
  }

  /**
   * @returns {number}
   */
  get quantity() {
    return this._quantity;
  }

  /**
   * @returns {number}
   */
  set quantity(quantity) {
    this._quantity = quantity;
  }

  /**
   * @returns {number}
   */
  get variantID() {
    return this._variantID;
  }

  /**
   * @returns {string}
   */
  get key() {
    return this._key;
  }

  /**
   * @returns {string}
   */
  get title() {
    return this._title;
  }

  /**
   * @returns {number}
   */
  get price() {
    return this._price;
  }

  /**
   * @returns {number}
   */
  get originalPrice() {
    return this._originalPrice;
  }

  /**
   * @returns {number}
   */
  get discountedPrice() {
    return this._discountedPrice;
  }

  /**
   * @returns {number}
   */
  get linePrice() {
    return this._linePrice;
  }

  /**
   * @returns {number}
   */
  get originalLinePrice() {
    return this._originalLinePrice;
  }

  /**
   * @returns {number}
   */
  get totalDiscount() {
    return this._totalDiscount;
  }

  /**
   * @returns {array}
   */
  get discounts() {
    return this._discounts;
  }

  /**
   * @returns {string}
   */
  get sku() {
    return this._sku;
  }

  /**
   * @returns {number}
   */
  get grams() {
    return this._grams;
  }

  /**
   * @returns {string}
   */
  get vendor() {
    return this._vendor;
  }

  /**
   * @returns {boolean}
   */
  get taxable() {
    return this._taxable;
  }

  /**
   * @returns {number}
   */
  get productID() {
    return this._productID;
  }

  /**
   * @returns {boolean}
   */
  get giftCard() {
    return this._giftCard;
  }

  /**
   * @returns {number}
   */
  get finalPrice() {
    return this._finalPrice;
  }

  /**
   * @returns {number}
   */
  get finalLinePrice() {
    return this._finalLinePrice;
  }

  /**
   * @returns {string}
   */
  get url() {
    return this._url;
  }

  /**
   * @returns {string}
   */
  get image() {
    return this._image;
  }

  /**
   * @returns {string}
   */
  get handle() {
    return this._handle;
  }

  /**
   * @returns {boolean}
   */
  get requiresShipping() {
    return this._requiresShipping;
  }

  /**
   * @returns {string}
   */
  get productType() {
    return this._productType;
  }

  /**
   * @returns {string}
   */
  get productTitle() {
    return this._productTitle;
  }

  /**
   * @returns {string}
   */
  get productDescription() {
    return this._productDescription;
  }

  /**
   * @returns {string}
   */
  get variantTitle() {
    return this._variantTitle;
  }

  /**
   * @returns {array}
   */
  get variantOptions() {
    return this._variantOptions;
  }

  /**
   * @returns {array}
   */
  get lineLevelDiscountAllocations() {
    return this._lineLevelDiscountAllocations;
  }

  /**
   *
   * @return {Object} - Shopify Cart Item Object.
   */
  JSON() {
    return {
      discounted_price: this.discountedPrice,
      discounts: this.discounts,
      final_line_price: this.finalLinePrice,
      final_price: this.finalPrice,
      gift_card: this.giftCard,
      grams: this.grams,
      handle: this.handle,
      id: super.id,
      image: this.image,
      key: this.key,
      line_level_discount_allocations: this.lineLevelDiscountAllocations,
      line_price: this.linePrice,
      original_line_price: this.originalLinePrice,
      original_price: this.originalPrice,
      price: this.price,
      product_description: this.productDescription,
      product_id: this.productID,
      product_title: this.productTitle,
      product_type: this.productType,
      properties: this.properties,
      quantity: this.quantity,
      requires_shipping: this.requiresShipping,
      sku: this.sku,
      taxable: this.taxable,
      title: this.title,
      total_discount: this.totalDiscount,
      url: this.url,
      variant_id: this.variantID,
      variant_options: this.variantOptions,
      variant_title: this.variantTitle,
      vendor: this.vendor,
    };
  }
}
